import React, { lazy, useEffect } from 'react';
import LazySection from 'components/lazySection';
import SectionSkeleton from './sectionskeleton';
import { useLocation } from 'react-router-dom';
const ProjectBanner = lazy(() => import("components/projects/projectBanner"));
const ProjectAbout = lazy(() => import("components/projects/projectAbout"));
const ProjectOurProject = lazy(() => import("components/projects/projectOurProject"));
const Project: React.FC = () => {
   const location = useLocation();

 
  return (
      <>
        <ProjectBanner/>
        {/* Lazy load sections when visible */}
        <LazySection fallback={<SectionSkeleton height={400} />}>
            <ProjectAbout />
        </LazySection>

        <LazySection fallback={<SectionSkeleton height={400} />}>
            <ProjectOurProject hash={location.hash} />
        </LazySection>
        
        
      </>
  );
};

export default Project;
